import "@/App.css";
import InvoiceApp from "@/pages/InvoiceApp";
import { Toaster } from "@/components/ui/sonner";

export default function App() {
  return (
    <div className="App">
      <InvoiceApp />
      <Toaster
        position="bottom-right"
        toastOptions={{
          classNames: {
            toast:
              "rounded-none border-2 border-black bg-white text-black font-medium",
          },
        }}
      />
    </div>
  );
}
